import type { TipMode } from "Components/Shared/TipSelector/types";

const TIP_PERCENT_BY_MODE: Record<TipMode, number> = {
  none: 0,
  fivePercent: 0.05,
  tenPercent: 0.1,
  twentyPercent: 0.2,
  custom: 0,
};

const roundToCents = (amount: number) => Math.round(amount * 100) / 100;

export const computeTipAmount = (
  tipMode: TipMode,
  customTipAmount: number | undefined,
  billAmount: number,
) => {
  if (tipMode === "custom") {
    return customTipAmount && customTipAmount > 0
      ? roundToCents(customTipAmount)
      : 0;
  }
  return roundToCents(billAmount * TIP_PERCENT_BY_MODE[tipMode]);
};
